import { createSlice } from "@reduxjs/toolkit";
import moment from 'moment';

const initialState = {
    participante: {
        id: 0,
        idPersona: 0,
        participante: "",
        fechaIngreso: moment().format('yyyy-MM-DD'),
        idNivelLenguaje: 0,
        nivelLenguaje: "",
        tieneEscolaridad: false,
        idColegio: 0,
        colegio: "",
        idGradoColegio: 0,
        gradoColegio: "",
        tieneSeguro: false,
        idTipoSeguro: 0,
        tipoSeguro: "",
        detalleSeguro: "",
        tieneHermanos: false,
        detalleHermanos: "",
        detalleConvivencia: "",
        tieneDiagnostico: false,
        fechaUltimoDiagnostico: null,
        asisteATerapia: false,
        idTipoTerapia: 0,
        tipoTerapia: "",
        lugarCasoAccidente: "",
        idDireccionCasoAccidente: null,
        ubigeoCasoAccidente: "",
        direccionCasoAccidente: "",
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    },
    listParticipantes: [{ id: 0, descripcion: "" }],
    listNivelLenguaje: [{ id: 0, descripcion: "" }],
    listColegio: [{ idPersona: 0, nombres: "" }],
    listGradoColegio: [{ id: 0, descripcion: "" }],
    listTipoSeguro: [{ id: 0, descripcion: "" }],
    listTipoTerapia: [{ id: 0, descripcion: "" }],
    validationActive: {
        participante: false,
        terapeuta: false,
        fechaIngreso: false,
    },
    validationMessage: [],
  }
  
  export const memberSlice = createSlice({
    name: "member",
    initialState,
    reducers: {
      setEntity: (state, action) => {
        state.participante = action.payload;
      },
      setData: (state, action) => {
        var { name, value } = action.payload;
  
        if (name.startsWith("id")) value = parseInt(value)
        
        state.participante[name] = value
        state.validationActive[name] = true
      },
      setValidationMessage: (state, action) => {
        state.validationMessage = action.payload;
      },
      activeValidations: (state, action) => {
        Object.keys(state.validationActive).forEach(function (key) {
          state.validationActive[key] = true;
        })
      },
      setListParticipantes: (state, action) => {
        state.listParticipantes = action.payload;
      },
      setListNivelLenguaje: (state, action) => {
        state.listNivelLenguaje = action.payload;
      },
      setListColegio: (state, action) => {
        state.listColegio = action.payload;
      },
      setListGradoColegio: (state, action) => {
        state.listGradoColegio = action.payload;
      },
      setListTipoSeguro: (state, action) => {
        state.listTipoSeguro = action.payload;
      },
      setListTipoTerapia: (state, action) => {
        state.listTipoTerapia = action.payload;
      },
    },
  });
  export const { setEntity, setData, setValidationMessage, activeValidations
    , setListParticipantes, setListNivelLenguaje, setListColegio, setListGradoColegio, setListTipoSeguro, setListTipoTerapia } = memberSlice.actions;
  export const defaultParticipante = {
      id: 0,
      idPersona: 0,
      participante: "",
      fechaIngreso: moment().format('yyyy-MM-DD'),
      idNivelLenguaje: 0,
      nivelLenguaje: "",
      tieneEscolaridad: false,
      idColegio: 0,
      colegio: "",
      idGradoColegio: 0,
      gradoColegio: "",
      tieneSeguro: false,
      idTipoSeguro: 0,
      tipoSeguro: "",
      detalleSeguro: "",
      tieneHermanos: false,
      detalleHermanos: "",
      detalleConvivencia: "",
      tieneDiagnostico: false,
      fechaUltimoDiagnostico: null,
      asisteATerapia: false,
      idTipoTerapia: 0,
      tipoTerapia: "",
      lugarCasoAccidente: "",
      idDireccionCasoAccidente: null,
      ubigeoCasoAccidente: "",
      direccionCasoAccidente: "",
      fechaRegistro: null,
      usuarioRegistro: null,
      fechaModificacion: null,
      usuarioModificacion: null,
  }
  export default memberSlice.reducer;
  